var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "manager_dashboard" },
    [
      _c("user-menu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _c("EnterpriseAdminSidebarMenu", {
            attrs: {
              show_menu: false,
              show_back_button: true,
              back_link: "enterpriseadminreports"
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "content-wrapper padding-left-165" }, [
            _c(
              "div",
              { staticClass: "container-wrapper center" },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showOverlay,
                        expression: "showOverlay"
                      }
                    ],
                    staticClass: "modal-custom"
                  },
                  [_vm._m(0)]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("div", { staticClass: "my-3" }),
                    _vm._v(" "),
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 float-left text-left pl-0" },
                      [
                        _vm.subtasks.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "margin-t-2 float-right pl-2",
                                on: {
                                  click: function($event) {
                                    return _vm.shareButtonModal()
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  staticClass: "cursor-pointer",
                                  attrs: {
                                    src: require("@/assets/Send_Report_Button.svg"),
                                    alt: "MentorMentee",
                                    width: "24px"
                                  }
                                })
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.subtasks.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "margin-t-2 float-right pl-2 mr-2",
                                on: {
                                  click: function($event) {
                                    return _vm.downloadFunc()
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  staticClass: "cursor-pointer",
                                  attrs: {
                                    src: require("@/assets/Download_Report.svg"),
                                    alt: "MentorMentee",
                                    width: "24px"
                                  }
                                })
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "clear" })
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "clear" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "border-bottom mt-1 mb-2" }),
                    _vm._v(" "),
                    _vm.loading == false
                      ? _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-md-12 offset-md-0" },
                            [
                              _c(
                                "b-navbar",
                                {
                                  attrs: {
                                    toggleable: "lg",
                                    type: "light",
                                    variant: "light"
                                  }
                                },
                                [
                                  _c(
                                    "b-navbar-brand",
                                    { attrs: { href: "#" } },
                                    [_vm._v("Filter")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-navbar-toggle",
                                    { attrs: { target: "nav-collapse" } },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-chevron-down "
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-collapse",
                                    {
                                      attrs: {
                                        id: "nav-collapse",
                                        "is-nav": ""
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "search-wrapper col-12"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "row col-12 override-padding pb-2 border-location"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-3 pl-0" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "cp-filter-label pr-2"
                                                    },
                                                    [_vm._v("Location:")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("b-form-select", {
                                                    staticClass:
                                                      "col-8 margin-bottom-10",
                                                    attrs: {
                                                      options:
                                                        _vm.report_all_locations
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.updateAccountAction()
                                                      }
                                                    },
                                                    model: {
                                                      value: _vm.accountId,
                                                      callback: function($$v) {
                                                        _vm.accountId = $$v
                                                      },
                                                      expression: "accountId"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "col-3" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "cp-filter-label pr-2"
                                                    },
                                                    [_vm._v("User:")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("b-form-select", {
                                                    staticClass:
                                                      "col-8 margin-bottom-10",
                                                    attrs: {
                                                      options: _vm.menteeLists
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.updateMenteeTasklistAction()
                                                      }
                                                    },
                                                    model: {
                                                      value: _vm.rep_mentee,
                                                      callback: function($$v) {
                                                        _vm.rep_mentee = $$v
                                                      },
                                                      expression: "rep_mentee"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "col-3 pl-0" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "cp-filter-label pr-2"
                                                    },
                                                    [_vm._v("Task Lists:")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("b-form-select", {
                                                    staticClass:
                                                      "col-8 margin-bottom-10",
                                                    attrs: {
                                                      options: _vm.taskLists
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.filterCompetency()
                                                      }
                                                    },
                                                    model: {
                                                      value: _vm.rep_task_list,
                                                      callback: function($$v) {
                                                        _vm.rep_task_list = $$v
                                                      },
                                                      expression:
                                                        "rep_task_list"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-2 pr-0 text-right search-icon-wrapper cursor-pointer"
                                                },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-info btn-md font-weight-bold rounded-pill",
                                                      attrs: { type: "button" },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.filterCompetency()
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("Filter")]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "clear" }),
                    _vm._v(" "),
                    _vm.loading == true
                      ? _c("div", { staticClass: "row top-content" }, [
                          _c(
                            "div",
                            { staticClass: "col-3 p-0 pl-4" },
                            [
                              _c("PuSkeleton", {
                                attrs: { height: "30px", count: 1 }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-3 text-right p-0 pl-3" },
                            [
                              _c("PuSkeleton", {
                                attrs: { height: "30px", count: 1 }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-3 text-right p-0 pl-3" },
                            [
                              _c("PuSkeleton", {
                                attrs: { height: "30px", count: 1 }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-3 text-right p-0 pl-3 pr-3" },
                            [
                              _c(
                                "div",
                                { staticClass: "col-9" },
                                [
                                  _c("PuSkeleton", {
                                    attrs: { height: "30px", count: 1 }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(3, function(option) {
                      return _vm.loading == true
                        ? _c("div", { staticClass: "col-md-12 mb-2" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-md-8 offset-md-2 border shadow float-left subtask-list-layout pt-1 px-3 margin-t-10"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "row row align-items-center" },
                                  [
                                    _c("div", { staticClass: "col-7" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "cp-title col-4 text-left"
                                        },
                                        [
                                          _c("PuSkeleton", {
                                            attrs: { count: 1, width: "" }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "cp-text col-7" },
                                        [
                                          _c("PuSkeleton", {
                                            attrs: { count: 1 }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "cp-text col-7" },
                                        [
                                          _c("PuSkeleton", {
                                            attrs: { count: 1 }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "cp-text col-7" },
                                        [
                                          _c("PuSkeleton", {
                                            attrs: { count: 1 }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "cp-text col-6" },
                                        [
                                          _c("PuSkeleton", {
                                            attrs: { count: 1 }
                                          })
                                        ],
                                        1
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-5 text-right pad-right"
                                      },
                                      [
                                        _c("PuSkeleton", {
                                          attrs: {
                                            circle: "",
                                            height: "120px",
                                            width: "120px",
                                            count: 1
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        : _vm._e()
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12 mb-2" }, [
                      _vm.isOverviewVisible && _vm.loading == false
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "col-md-8 offset-md-2 border shadow float-left subtask-list-layout pt-1 px-3 margin-t-10"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "row align-items-center" },
                                [
                                  _c("div", { staticClass: "col-7" }, [
                                    _c(
                                      "div",
                                      { staticClass: "cp-title text-left" },
                                      [_vm._v("Overview")]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "cp-text" }, [
                                      _vm._v(
                                        "Total Tasks in List: " +
                                          _vm._s(_vm.overviewTotalTaskCount)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "cp-text" }, [
                                      _vm._v(
                                        "Total Tasks Competent: " +
                                          _vm._s(
                                            _vm.overviewTotalCompetentTaskCount
                                          )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "cp-text" }, [
                                      _vm._v(
                                        "Total Time Submitted: " +
                                          _vm._s(
                                            _vm.calchoursonly(
                                              _vm.overviewTotaltime
                                            )
                                          )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "cp-text" }, [
                                      _vm._v(
                                        "\n              Remaining Tasks: " +
                                          _vm._s(
                                            _vm.overviewTotalRemainingTaskCount
                                          ) +
                                          "\n              "
                                      ),
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "ml-2 text-uppercase font-weight-bold",
                                          attrs: {
                                            href: "javascript:void(0);"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.displayOverviewRemainingTasks(
                                                _vm.overviewTotalRemainingTaskCount,
                                                _vm.overviewAllRemainingIds
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("view all")]
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-5" },
                                    [
                                      _c(
                                        "vc-donut",
                                        {
                                          attrs: {
                                            background: "white",
                                            foreground: "grey",
                                            size: 100,
                                            unit: "px",
                                            thickness: 30,
                                            sections: _vm.chartDataItems,
                                            total: 100,
                                            "start-angle": 0,
                                            "auto-adjust-text-size": true
                                          }
                                        },
                                        [
                                          _c("h1", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.competentPercentValue
                                              ) + "%"
                                            )
                                          ])
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "clear" })
                            ]
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "clear" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {},
                      _vm._l(_vm.subtasks, function(subtask, sindex) {
                        return _c(
                          "div",
                          { key: sindex, staticClass: "col-md-12 mb-2" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-md-8 offset-md-2 shadow border float-left subtask-list-layout pt-1 px-3"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "row align-items-center" },
                                  [
                                    _c("div", { staticClass: "col-7" }, [
                                      _c(
                                        "div",
                                        { staticClass: "cp-title text-left" },
                                        [_vm._v(_vm._s(subtask.name))]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "cp-text" }, [
                                        _vm._v(
                                          "Total Tasks in Section: " +
                                            _vm._s(
                                              subtask.subtask_total_stats
                                                .totalTaskCount
                                            )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "cp-text" }, [
                                        _vm._v(
                                          "Total Tasks Competent: " +
                                            _vm._s(
                                              subtask.subtask_total_stats
                                                .totalCompetentTaskCount
                                            )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "cp-text" }, [
                                        _vm._v(
                                          "Total Time Submitted: " +
                                            _vm._s(
                                              _vm.calchoursonly(
                                                subtask.totalTime
                                              )
                                            )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "cp-text" }, [
                                        _vm._v(
                                          "\n                        Remaining Tasks: " +
                                            _vm._s(
                                              subtask.subtask_total_stats
                                                .totalRemainingTaskCount
                                            ) +
                                            "\n                        "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "ml-2 text-uppercase font-weight-bold",
                                            attrs: {
                                              href: "javascript:void(0);"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.displayRemainingTasks(
                                                  subtask.name,
                                                  subtask.subtask_total_stats
                                                    .totalRemainingTaskCount,
                                                  subtask.subtask_total_stats
                                                    .viewAllRemainingIds
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("view all")]
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-5" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "cp-toggle-icon" },
                                          [
                                            _c(
                                              "b-link",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-toggle",
                                                    rawName: "v-b-toggle",
                                                    value:
                                                      "collapse-" + subtask.id,
                                                    expression:
                                                      "'collapse-' + subtask.id"
                                                  }
                                                ],
                                                on: {
                                                  click: function($event) {
                                                    return _vm.getFontIcon(
                                                      subtask.id
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-angle-down",
                                                  attrs: {
                                                    id: "angle-" + subtask.id,
                                                    "aria-hidden": "true"
                                                  }
                                                })
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "vc-donut",
                                          {
                                            attrs: {
                                              background: "white",
                                              foreground: "grey",
                                              size: 100,
                                              unit: "px",
                                              thickness: 30,
                                              sections:
                                                subtask.competent_percent,
                                              total: 100,
                                              "start-angle": 0,
                                              "auto-adjust-text-size": true
                                            }
                                          },
                                          [
                                            _c("h1", [
                                              _vm._v(
                                                _vm._s(
                                                  subtask.competent_percent[0]
                                                    .value
                                                ) + "%"
                                              )
                                            ])
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-collapse",
                                  {
                                    staticClass: "mt-2",
                                    attrs: { id: "collapse-" + subtask.id }
                                  },
                                  [
                                    _vm._l(subtask.headings, function(
                                      heading,
                                      index
                                    ) {
                                      return subtask.headings.length > 0
                                        ? _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass: "cp-heading-lists"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "row cp-heading-title"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-12" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(heading.name)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(heading.tasks, function(
                                                task,
                                                tindex
                                              ) {
                                                return heading.tasks.length > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        key: tindex,
                                                        staticClass:
                                                          "row px-3 heading-tasks"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-12 cp-task-desc"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                tindex +
                                                                  1 +
                                                                  ". " +
                                                                  task.description
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            class:
                                                              "col-12 " +
                                                              _vm.getRatedClass(
                                                                task.three_plus_rated_count
                                                              )
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                task.three_plus_rated_count
                                                              ) +
                                                                " Reps Rated 3+"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-12 cp-see-all-reps"
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                attrs: {
                                                                  href:
                                                                    "javascript:void(0);"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.reportViewTaskRepitition(
                                                                      task.id,
                                                                      task.description,
                                                                      subtask.name,
                                                                      heading.name
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "See All Task Reps"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              })
                                            ],
                                            2
                                          )
                                        : _vm._e()
                                    }),
                                    _vm._v(" "),
                                    subtask.tasks.length > 0
                                      ? _c(
                                          "div",
                                          _vm._l(subtask.tasks, function(
                                            task,
                                            tindex
                                          ) {
                                            return _c(
                                              "div",
                                              {
                                                key: tindex,
                                                staticClass:
                                                  "row px-3 heading-tasks"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "col-12" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        tindex +
                                                          1 +
                                                          ". " +
                                                          task.description
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    class:
                                                      "col-12 " +
                                                      _vm.getRatedClass(
                                                        task.three_plus_rated_count
                                                      )
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        task.three_plus_rated_count
                                                      ) + " Reps Rated 3+"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-12 cp-see-all-reps"
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href:
                                                            "javascript:void(0);"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.reportViewTaskRepitition(
                                                              task.id,
                                                              task.description,
                                                              subtask.name,
                                                              ""
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "See All Task Reps"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          }),
                                          0
                                        )
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "clear" })
                          ]
                        )
                      }),
                      0
                    )
                  ],
                  2
                ),
                _vm._v(" "),
                _c("OverviewRemainingTasks", {
                  ref: "overview_tasks",
                  attrs: {
                    isModalVisible: _vm.isOverviewRemainingModalVisible,
                    tasklistId: _vm.taskListID
                  },
                  on: {
                    close: function($event) {
                      _vm.isOverviewRemainingModalVisible = false
                    }
                  }
                }),
                _vm._v(" "),
                _c("ViewRemainingTasks", {
                  ref: "remaining_tasks",
                  attrs: {
                    isModalVisible: _vm.isViewRemainingModalVisible,
                    tasklistId: _vm.taskListID
                  },
                  on: {
                    close: function($event) {
                      _vm.isViewRemainingModalVisible = false
                    }
                  }
                }),
                _vm._v(" "),
                _c("EnterpriseAdminViewTaskRepitition", {
                  ref: "report_view_task_reps",
                  attrs: {
                    isModalVisible: _vm.isReportViewTaskModalVisible,
                    tasklistId: _vm.taskListID,
                    menteeId: _vm.menteeId,
                    paramAccountId: _vm.accountId
                  },
                  on: {
                    close: function($event) {
                      _vm.isReportViewTaskModalVisible = false
                    }
                  }
                })
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("EnterpriseAdminOverlaySidebar", {
        ref: "location_sidebar",
        attrs: { isModalVisible: _vm.isModalVisible, readOnly: _vm.isReadOnly },
        on: { close: _vm.closeSidebar }
      }),
      _vm._v(" "),
      _c(
        "ShareReportModal",
        {
          attrs: { isModalVisible: _vm.isShareModalVisible },
          on: {
            close: function($event) {
              _vm.isShareModalVisible = false
            }
          }
        },
        [
          _vm.loading
            ? _c("span", { staticClass: "pull-right text-danger" }, [
                _vm._v("\n      Loading...\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sub-heading",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_c("h3", [_vm._v("Share Report")])]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "body" }, slot: "body" }, [
            _vm.showShareSuccess == true
              ? _c(
                  "div",
                  { staticClass: "col-12 override-padding success_msg" },
                  [_c("b", [_vm._v("Report shared successfully!")])]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 override-padding" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.share_email,
                    expression: "share_email"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|email",
                    expression: "'required|email'"
                  }
                ],
                staticClass:
                  "col-lg-12 input-text form-control input-height-35",
                attrs: {
                  name: "share_email",
                  placeholder: "Enter Email...",
                  "data-vv-as": "Email address",
                  maxlength: "255"
                },
                domProps: { value: _vm.share_email },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.share_email = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.verrors.has("share_email"),
                      expression: "verrors.has('share_email')"
                    }
                  ],
                  staticClass: "validate-warning-msg"
                },
                [_vm._v(_vm._s(_vm.verrors.first("share_email")))]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "clear margin-bottom-10" }),
            _vm._v(" "),
            _vm.showWait == false
              ? _c(
                  "div",
                  { staticClass: "col-12 override-padding text-align-right" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-dard-grey col-lg-3",
                        on: {
                          click: function($event) {
                            return _vm.shareButtonSubmit()
                          }
                        }
                      },
                      [_c("b", [_vm._v(_vm._s(_vm.submit_text))])]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showWait == true
              ? _c(
                  "div",
                  { staticClass: "col-12 override-padding text-align-right" },
                  [
                    _c(
                      "button",
                      { staticClass: "btn btn-dard-grey col-lg-3" },
                      [_c("b", [_vm._v("Please wait...")])]
                    )
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "col-3 override-padding",
            attrs: { slot: "footer" },
            slot: "footer"
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loader-img-center" }, [
      _c("i", { staticClass: "fa fa-spinner fa-spin" }),
      _vm._v(" Please wait...\n          ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-9 float-left text-left pl-0" }, [
      _c("h3", { staticClass: "d-inline heading text-uppercase" }, [
        _vm._v("Competency Progress")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-90991396", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90991396","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/enterpriseadmin/competency_report.vue
// module id = null
// module chunks = 